if (document.querySelector('[data-noble-home-best-sellers]')) {
(() => {
  if (window.nobleShopAllCadence) return;
  window.nobleShopAllCadence = true;

  const positionRotations = {
    4: [4, 1, 3, 2],
    3: [3, 1, 2],
    2: [2, 1],
    1: [1]
  };
  const curatedShopAllHandles = [
    'antioxidant-repair-balm',
    'clarify-serum',
    'eucalyptus-bergamot-tallow-body-cream',
    'citrus-vanilla-tallow-deodorant',
    'soothe-toner',
    'rejuvenate-tallow-face-cream',
    'cleansing-oil',
    'barrier-rescue-balm',
    'rejuvenate-serum',
    'orange-vanilla-whipped-tallow-whole-body-cream',
    'eucalyptus-bergamot-tallow-deodorant',
    'clarify-toner',
    'soothe-tallow-face-cream-for-sensitive-or-reactive-skin',
    'build-your-daily-ritual',
    'rejuvenate-toner',
    'soothe-serum',
    'lavender-eucalyptus-whipped-tallow-face-body-cream-v1-copy',
    'geranium-tallow-deodorant',
    'clarify-face-mask',
    'rose-lemon-vanilla-face-cream',
    'noble-mini-toner-trio',
    'nourish-soothe-eye-balm',
    'atlas-cedarwood-bergamot-whipped-tallow-face-body-cream',
    'lavender-tallow-deodorant',
    'clarify-tallow-face-cream',
    'rejuvenating-face-mask',
    'glow-up-serum',
    'orange-chamomile',
    'eucalyptus-lemongrass-tallow-deodorant',
    'balance-hydrate-toner-for-combination-and-oily-skin',
    'bare-unscented-whipped-tallow',
    'noble-serum-trio'
  ];
  const productHandle = (item) => {
    const href = item.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
    return href.split('/products/')[1]?.split(/[?#/]/)[0] || '';
  };
  let queued = false;

  const placeEditorials = () => {
    queued = false;
    const grid = document.querySelector('#product-grid[data-noble-collection]');
    if (!grid) return;

    const children = [...grid.children].filter((item) => item.tagName === 'LI');
    const editorials = children.filter((item) => item.classList.contains('noble-collection-editorial'));
    let products = children.filter((item) => !item.classList.contains('noble-collection-editorial'));

    if (grid.dataset.nobleCollection === 'all') {
      const priority = new Map(curatedShopAllHandles.map((handle, index) => [handle, index]));
      const originalOrder = new Map(products.map((product, index) => [product, index]));
      const orderedProducts = [...products].sort((a, b) => {
        const aPriority = priority.get(productHandle(a));
        const bPriority = priority.get(productHandle(b));
        if (aPriority !== undefined && bPriority !== undefined) return aPriority - bPriority;
        if (aPriority !== undefined) return -1;
        if (bPriority !== undefined) return 1;
        return originalOrder.get(a) - originalOrder.get(b);
      });

      if (orderedProducts.some((product, index) => product !== products[index])) {
        orderedProducts.forEach((product) => grid.appendChild(product));
        products = orderedProducts;
      }
    }

    grid.classList.toggle('noble-shop-all-cadence', editorials.length > 0);
    if (!editorials.length || !products.length) return;

    // Measure the collection's rendered columns instead of assuming a viewport
    // breakpoint. The filter sidebar can reduce a nominal three-column tablet
    // grid to two columns, and the editorial must still occupy one product cell.
    editorials.forEach((editorial) => {
      editorial.hidden = true;
      editorial.style.display = 'none';
      editorial.style.setProperty('grid-column', 'auto', 'important');
      editorial.style.removeProperty('flex-basis');
      editorial.style.removeProperty('width');
      editorial.style.removeProperty('max-width');
      editorial.style.removeProperty('margin-inline-start');
      editorial.style.removeProperty('margin-inline-end');
    });

    const firstRowTop = Math.round(products[0].getBoundingClientRect().top);
    const measuredColumns = Math.max(1, products.filter((product) => (
      Math.abs(Math.round(product.getBoundingClientRect().top) - firstRowTop) <= 2
    )).length);
    const firstPass = grid.dataset.nobleEditorialFirstPass === 'true';
    const cellWidth = products[0].getBoundingClientRect().width;
    const columnGap = parseFloat(getComputedStyle(grid).columnGap) || 0;
    const columns = firstPass ? Math.max(1, Math.round((grid.getBoundingClientRect().width + columnGap) / (cellWidth + columnGap))) : measuredColumns;
    const positions = positionRotations[columns] || Array.from({ length: columns }, (_, index) => index + 1);
    const productsPerEditorialCycle = columns * 2 - 1;
    const productCellWidth = `${products[0].getBoundingClientRect().width}px`;
    const photoPositions = {"rollout_serum_use":"40% center","editorial_serum_body":"center","rollout_toner_prepare":"center","rollout_mask_pair":"center","editorial_eye_soothe":"center","rollout_face_ritual":"center","rollout_face_soothe":"40% center","rollout_face_rejuvenate":"center","editorial_face_discovery":"center","rollout_body_tallow":"center","rollout_body_barrier":"center","rollout_body_family":"40% center","editorial_body_refresh":"center","rollout_deodorant_use":"center","editorial_deodorant_moisture":"center"};
    if (firstPass) editorials.forEach(editorial => {
      const headingId = editorial.querySelector('.noble-collection-editorial__title')?.id || '';
      editorial.dataset.noblePhotoPosition = photoPositions[headingId.replace('Editorial-', '')] || 'center';
    });
    if (firstPass) {
      const editorialOrder = Object.keys(photoPositions);
      editorials.sort((a, b) => editorialOrder.indexOf((a.querySelector('.noble-collection-editorial__title')?.id || '').replace('Editorial-', '')) - editorialOrder.indexOf((b.querySelector('.noble-collection-editorial__title')?.id || '').replace('Editorial-', '')));
    }
    const productCardHeight = Math.max(...products.map(product => product.querySelector('.card-wrapper')?.getBoundingClientRect().height || 0));
    const serumPair = firstPass && grid.dataset.nobleCollection === 'serums' && products.length === 6;
    const tonerRow = firstPass && grid.dataset.nobleCollection === 'toners' && products.length === 3;
    const eyePair = firstPass && grid.dataset.nobleCollection === 'eyes' && products.length === 1;

    for (let index = editorials.length - 1; index >= 0; index -= 1) {
      const editorial = editorials[index];
      let editorialColumn = positions[index % positions.length];
      const intendedAfterProduct = index * productsPerEditorialCycle + columns + editorialColumn - 1;
      let afterProduct = firstPass && index === 0 && (products.length <= 4 || (products.length >= columns && products.length < productsPerEditorialCycle)) ? products.length : intendedAfterProduct;
      if (serumPair) {
        afterProduct = index < 2 ? (index + 1) * 3 : 0;
        editorialColumn = ((afterProduct + index) % columns) + 1;
      } else if (tonerRow || eyePair) {
        afterProduct = index === 0 ? products.length : 0;
        editorialColumn = (products.length % columns) + 1;
      }
      const anchor = products[afterProduct - 1];

      const completeEditorialCycle = products.length >= (index + 1) * productsPerEditorialCycle;
      if (!anchor || (!firstPass && !completeEditorialCycle)) {
        editorial.hidden = true;
        editorial.style.display = 'none';
        continue;
      }

      editorial.hidden = false;
      editorial.style.removeProperty('display');
      editorial.dataset.nobleAfterProduct = String(afterProduct);
      editorial.dataset.nobleEditorialColumn = String(editorialColumn);
      editorial.style.flexBasis = productCellWidth;
      editorial.style.width = productCellWidth;
      editorial.style.maxWidth = productCellWidth;
      if (firstPass) {
        if (!tonerRow && !eyePair && products.length <= 4) {
          editorial.style.marginInlineEnd = `${(columns - 1) * (cellWidth + columnGap)}px`;
          editorial.style.setProperty('grid-column', '1', 'important');
        } else if (!serumPair && !tonerRow && !eyePair && index === 0 && afterProduct < intendedAfterProduct) {
          editorial.style.marginInlineStart = `${(intendedAfterProduct - afterProduct) * (cellWidth + columnGap)}px`;
        }
        editorial.style.setProperty('--noble-cross-sell-height', `${productCardHeight}px`);
        editorial.querySelector('.noble-collection-editorial__image')?.style.setProperty('object-position', editorial.dataset.noblePhotoPosition || 'center');
      }
      if (anchor.nextElementSibling !== editorial) anchor.after(editorial);
    }
  };

  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(placeEditorials);
  };

  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  schedule();
})();

(() => {
  if (window.nobleCollectionHoverMedia) return;
  window.nobleCollectionHoverMedia = true;

  const filesRoot = 'https://cdn.shopify.com/s/files/1/0673/0147/4485/files/';
  const primaryScaleOverrides = {
    'antioxidant-repair-balm': 1.45,
    'clarify-serum': 1.5,
    'eucalyptus-bergamot-tallow-body-cream': 1.8,
    'citrus-vanilla-tallow-deodorant': 1.5,
    'soothe-toner': 1.5,
    'rejuvenate-tallow-face-cream': 2.1,
    'cleansing-oil': 1.4,
    'barrier-rescue-balm': 2.1,
    'rejuvenate-serum': 1.5,
    'orange-vanilla-whipped-tallow-whole-body-cream': 1.8,
    'eucalyptus-bergamot-tallow-deodorant': 1.5,
    'clarify-toner': 1.5,
    'soothe-tallow-face-cream-for-sensitive-or-reactive-skin': 2.1,
    'rejuvenate-toner': 1.5,
    'soothe-serum': 1.5,
    'lavender-eucalyptus-whipped-tallow-face-body-cream-v1-copy': 1.8,
    'geranium-tallow-deodorant': 1.5,
    'eucalyptus-lemongrass-tallow-deodorant': 1.5,
    'lavender-tallow-deodorant': 1.5,
    'orange-lemongrass-tallow-deodorant': 1.5,
    'vanilla-bean-tallow-deodorant': 1.5,
    'ylang-ylang-blue-tansy-tallow-deodorant': 1.5
  };
  const primaryShiftOverrides = {
    'antioxidant-repair-balm': '0%',
    'clarify-serum': '5%',
    'eucalyptus-bergamot-tallow-body-cream': '10%',
    'citrus-vanilla-tallow-deodorant': '6%',
    'soothe-toner': '5%',
    'rejuvenate-tallow-face-cream': '12%',
    'cleansing-oil': '5%',
    'barrier-rescue-balm': '12%',
    'rejuvenate-serum': '5%',
    'orange-vanilla-whipped-tallow-whole-body-cream': '10%',
    'eucalyptus-bergamot-tallow-deodorant': '6%',
    'clarify-toner': '5%',
    'soothe-tallow-face-cream-for-sensitive-or-reactive-skin': '12%',
    'rejuvenate-toner': '5%',
    'soothe-serum': '5%',
    'lavender-eucalyptus-whipped-tallow-face-body-cream-v1-copy': '10%',
    'geranium-tallow-deodorant': '6%',
    'eucalyptus-lemongrass-tallow-deodorant': '6%',
    'lavender-tallow-deodorant': '6%',
    'orange-lemongrass-tallow-deodorant': '6%',
    'vanilla-bean-tallow-deodorant': '6%',
    'ylang-ylang-blue-tansy-tallow-deodorant': '6%'
  };
  const approvedProductMedia = {
  "radiance-lavender-frankincense-face-cream": {
    "mediaId": "65477270208693",
    "identity": "nobleskinco-fall2026-01222.jpg?1791223032",
    "type": "texture",
    "alt": "Lavender & Frankincense Face Tallow texture"
  },
  "tea-tree-frankincense": {
    "mediaId": "65477959123125",
    "identity": "1M1A3479_1.jpg?1791226753",
    "type": "application",
    "alt": "Tea Tree & Frankincense Face Tallow application"
  },
  "baby-balm": {
    "mediaId": "65478075449525",
    "identity": "1M1A5535.jpg?1791227387",
    "type": "application",
    "alt": "Baby Balm application"
  },
  "barrier-rescue-balm": {
    "mediaId": "65478268747957",
    "identity": "1M1A3796.jpg?1791228899",
    "type": "application",
    "alt": "Barrier Rescue Balm texture dispensed from its jar"
  },
  "lavender-eucalyptus-whipped-tallow-face-body-cream-v1-copy": {
    "mediaId": "65477973639349",
    "identity": "1M1A3725_1.jpg?1791226879",
    "type": "application",
    "alt": "Lavender Eucalyptus Body Tallow application"
  },
  "dry-shampoo": {
    "mediaId": "65478513950901",
    "identity": "nobleskinco-08465_2.jpg?1791231497",
    "type": "texture",
    "alt": "Herbal Dry Shampoo powder texture"
  },
  "nourish-soothe-eye-balm": {
    "mediaId": "65478523519157",
    "identity": "1M1A4855.jpg?1791231714",
    "type": "application",
    "alt": "Soothe Eye Balm applied around the eye"
  },
  "antioxidant-repair-balm": {
    "mediaId": "65429546696885",
    "identity": "noble-skin-co-antioxidant-repair-balm-ava-lifestyle.jpg?1790798002",
    "type": "lifestyle",
    "alt": "Antioxidant Repair Balm skincare ritual"
  },
  "rejuvenating-face-mask": {
    "mediaId": "65476993777845",
    "identity": "nobleskinco-08474-2.jpg?1791220615",
    "type": "application",
    "alt": "Rejuvenate Face Mask application"
  },
  "clear-skin-spirulina-face-mask": {
    "mediaId": "65476993614005",
    "identity": "nobleskinco-08468.jpg?1791220611",
    "type": "texture",
    "alt": "Soothe Face Mask texture dispensed from its jar"
  },
  "clarify-face-mask": {
    "mediaId": "65478439141557",
    "identity": "1M1A5759.jpg?1791230767",
    "type": "application",
    "alt": "Clarify Face Mask application"
  },
  "clarify-tallow-face-cream": {
    "mediaId": "65477958664373",
    "identity": "1M1A3513.jpg?1791226744",
    "type": "application",
    "alt": "Clarify Face Cream application"
  },
  "rejuvenate-tallow-face-cream": {
    "mediaId": "65478526468277",
    "identity": "nobleskinco-fall2026-01169-2.jpg?1791231783",
    "type": "texture",
    "alt": "Rejuvenate Face Cream texture"
  },
  "soothe-tallow-face-cream-for-sensitive-or-reactive-skin": {
    "mediaId": "65478685196469",
    "identity": "1M1A5047.jpg?1791233539",
    "type": "application",
    "alt": "Soothe Face Cream application"
  },
  "lip-cuticle-balm": {
    "mediaId": "65422215774389",
    "identity": "noble-skin-co-lip-cuticle-balm-peppermint-open-product.jpg?1790709560",
    "type": "detail",
    "alt": "Peppermint Lip & Cuticle Balm open tin and label"
  },
  "rejuvenate-serum": {
    "mediaId": "65478553927861",
    "identity": "1M1A5671.jpg?1791232179",
    "type": "application",
    "alt": "Rejuvenate Face Serum dispensed into the palm"
  },
  "soothe-serum": {
    "mediaId": "65478685065397",
    "identity": "1M1A4105.jpg?1791233535",
    "type": "sensory",
    "alt": "Soothe Face Serum bottle and glass dropper"
  },
  "clarify-serum": {
    "mediaId": "65478478528693",
    "identity": "1M1A4774_1.jpg?1791231179",
    "type": "sensory",
    "alt": "Clarify Face Serum bottle and glass dropper"
  },
  "cleansing-oil": {
    "mediaId": "65477220368565",
    "identity": "nobleskinco-08432.jpg?1791222564",
    "type": "texture",
    "alt": "Cleansing Oil texture and glass dropper"
  },
  "underarm-scrub": {
    "mediaId": "65477041651893",
    "identity": "nobleskinco-fall2026-01224.jpg?1791220867",
    "type": "texture",
    "alt": "Underarm Detox Scrub texture"
  },
  "vanilla-bean-tallow-deodorant": {
    "mediaId": "65422173143221",
    "identity": "noble-skin-co-vanilla-bean-deodorant-3oz-open-product.jpg?1790708778",
    "type": "detail",
    "alt": "Current-label Vanilla Bean Deodorant open 3 oz stick"
  },
  "orange-lemongrass-tallow-deodorant": {
    "mediaId": "65422160232629",
    "identity": "noble-skin-co-orange-lemongrass-deodorant-3oz-open-product.jpg?1790708298",
    "type": "detail",
    "alt": "Current-label Orange Lemongrass Deodorant open 3 oz stick"
  },
  "geranium-tallow-deodorant": {
    "mediaId": "65477908824245",
    "identity": "nobleskinco-fall2026-01213.jpg?1791226378",
    "type": "texture",
    "alt": "Geranium Deodorant texture"
  },
  "lavender-tallow-deodorant": {
    "mediaId": "65478168117429",
    "identity": "1M1A4900.jpg?1791227782",
    "type": "application",
    "alt": "Lavender Deodorant application"
  },
  "eucalyptus-bergamot-tallow-deodorant": {
    "mediaId": "65478019219637",
    "identity": "1M1A5903.jpg?1791227127",
    "type": "application",
    "alt": "Eucalyptus Bergamot Deodorant application"
  },
  "eucalyptus-lemongrass-tallow-deodorant": {
    "mediaId": "65476819157173",
    "identity": "1M1A5900.jpg?1791219057",
    "type": "application",
    "alt": "Eucalyptus Lemongrass Deodorant application"
  },
  "ylang-ylang-blue-tansy-tallow-deodorant": {
    "mediaId": "65477958566069",
    "identity": "1M1A3540.jpg?1791226742",
    "type": "application",
    "alt": "Ylang Ylang Blue Tansy Deodorant application"
  },
  "build-your-daily-ritual": {
    "mediaId": "65478343131317",
    "identity": "1M1A4203.jpg?1791229785",
    "type": "application",
    "alt": "Build Your Ritual skincare application"
  },
  "noble-serum-trio": {
    "mediaId": "65476993810613",
    "identity": "1M1A4055.jpg?1791220616",
    "type": "lifestyle",
    "alt": "Face Serum Trio in a skincare setting"
  }
};

  const style = document.createElement('style');
  style.textContent = `
    .product-grid > .flex-grid__item:not(.noble-collection-editorial) {
      align-self: stretch;
      display: flex;
    }
    .product-grid .card-wrapper.noble-purchase-prototype {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
    }
    .product-grid .card-wrapper.noble-purchase-prototype .card__media,
    .product-grid .card-wrapper.noble-purchase-prototype .card__media .media {
      width: 100%;
    }
    .product-grid .card-wrapper.noble-purchase-prototype .card__media .media {
      padding-bottom: 120% !important;
    }
    .product-grid .card-wrapper.noble-purchase-prototype .card__media .media > picture:first-of-type {
      transform: translateY(var(--noble-primary-shift, 0%)) scale(var(--noble-primary-scale, 1.42)) !important;
      transform-origin: center bottom !important;
    }
    .product-grid .card-wrapper.noble-purchase-prototype .card__media .media > picture:first-of-type > img {
      object-fit: contain !important;
      object-position: center bottom !important;
      transform: none !important;
    }
    .product-grid .card-wrapper.noble-purchase-prototype .card-information,
    .product-grid .card-wrapper.noble-purchase-prototype .card-information__wrapper {
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      width: 100%;
    }
    .product-grid .card-wrapper.noble-purchase-prototype .card-information__text {
      min-height: 4.8em;
    }
    .product-grid .card-wrapper.noble-purchase-prototype .noble-grid-price {
      display: flex;
      min-height: 2.75em;
      align-items: flex-start;
    }
    .product-grid .card-wrapper.noble-purchase-prototype .noble-card-rating {
      min-height: 1.5rem;
    }
    .product-grid .card-wrapper.noble-purchase-prototype .noble-grid-purchase {
      margin-top: auto;
    }
    .card__media .media > picture:nth-of-type(2) {
      position: absolute !important;
      inset: 0 !important;
      display: block !important;
      width: 100% !important;
      height: 100% !important;
      overflow: hidden !important;
      background: inherit;
    }
    .card-wrapper:not([data-noble-hover-approved="true"]) .card__media .media > picture:nth-of-type(2) {
      display: none !important;
    }
    .card-wrapper[data-noble-hover-approved="false"] .card__media .media > picture:first-of-type,
    .card-wrapper[data-noble-hover-approved="false"] .card__media .media > picture:first-of-type > img,
    .card-wrapper[data-noble-hover-approved="false"]:hover .card__media .media > picture:first-of-type,
    .card-wrapper[data-noble-hover-approved="false"]:hover .card__media .media > picture:first-of-type > img {
      display: block !important;
      opacity: 1 !important;
      visibility: visible !important;
    }
    .card__media .media > picture:nth-of-type(2) > img {
      position: absolute !important;
      inset: 0 !important;
      display: block !important;
      width: 100% !important;
      height: 100% !important;
      object-position: center center !important;
    }
    .card-wrapper[data-noble-hover-type="lifestyle"] .card__media .media > picture:nth-of-type(2) > img,
    .card-wrapper[data-noble-hover-type="application"] .card__media .media > picture:nth-of-type(2) > img,
    .card-wrapper[data-noble-hover-type="texture"] .card__media .media > picture:nth-of-type(2) > img {
      object-fit: cover !important;
    }
    .card-wrapper[data-noble-hover-type="detail"] .card__media .media > picture:nth-of-type(2) > img,
    .card-wrapper[data-noble-hover-type="fallback"] .card__media .media > picture:nth-of-type(2) > img {
      object-fit: contain !important;
    }
    @media (max-width: 749px), (hover: none), (pointer: coarse) {
      .card__media .media > picture:nth-of-type(2) {
        display: none !important;
      }
      .card-wrapper .card__media .media > picture:first-of-type,
      .card-wrapper .card__media .media > picture:first-of-type > img {
        display: block !important;
        opacity: 1 !important;
        visibility: visible !important;
      }
    }
  `;
  document.head.appendChild(style);

  const handleFromCard = (card) => {
    const href = card.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
    return href.split('/products/')[1]?.split(/[?#/]/)[0] || '';
  };

  const ensureHoverPicture = (media) => {
    let picture = media.querySelector(':scope > picture:nth-of-type(2)');
    if (picture) return picture;
    picture = document.createElement('picture');
    picture.className = 'motion-reduce';
    picture.appendChild(document.createElement('img'));
    media.appendChild(picture);
    return picture;
  };


  const productMediaChecks = new Map();
  const mediaIdentity = (src) => {
    try {
      const url = new URL(src, location.origin);
      return url.pathname.split('/').pop() + '?' + (url.searchParams.get('v') || '');
    } catch { return ''; }
  };
  const attachedHover = (handle, approval) => {
    if (!approval) return null;
    if (!productMediaChecks.has(handle)) {
      productMediaChecks.set(handle, null);
      const root = window.Shopify?.routes?.root || '/';
      fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', cache: 'no-store' })
        .then((response) => { if (!response.ok) throw new Error('Product media unavailable'); return response.json(); })
        .then((product) => {
          const media = product.handle === handle && Array.isArray(product.media) &&
            product.media.find((item) => String(item.id) === approval.mediaId &&
              item.media_type === 'image' && mediaIdentity(item.src) === approval.identity);
          const attached = media && Array.isArray(product.images) &&
            product.images.some((src) => mediaIdentity(src) === mediaIdentity(media.src));
          productMediaChecks.set(handle, attached ? {
            src: media.src,
            alt: approval.alt,
            type: approval.type
          } : false);
          scheduleHoverMedia();
        })
        .catch(() => { productMediaChecks.set(handle, false); scheduleHoverMedia(); });
    }
    return productMediaChecks.get(handle) || null;
  };

  const applyHoverMedia = () => {
    document.querySelectorAll('.product-grid .card-wrapper').forEach((card) => {
      card.classList.add('noble-purchase-prototype');
      const media = card.querySelector('.card__media .media');
      if (!media) return;
      const handle = handleFromCard(card);
      card.style.setProperty('--noble-primary-scale', String(primaryScaleOverrides[handle] || 1.42));
      card.style.setProperty('--noble-primary-shift', primaryShiftOverrides[handle] || '0%');
      const assignment = attachedHover(handle, approvedProductMedia[handle]);
      const picture = assignment ? ensureHoverPicture(media) : media.querySelector(':scope > picture:nth-of-type(2)');
      const image = picture?.querySelector('img');

      if (assignment && image) {
        let hoverSrc = assignment.src;
        if (card.closest('[data-noble-home-best-sellers]') &&
            ['lavender-eucalyptus-whipped-tallow-face-body-cream-v1-copy', 'rejuvenating-face-mask',
              'eucalyptus-bergamot-tallow-deodorant', 'soothe-serum'].includes(handle)) {
          const sizedHoverUrl = new URL(hoverSrc, location.origin);
          sizedHoverUrl.searchParams.set('width', '1100');
          hoverSrc = sizedHoverUrl.href;
        }
        if (image.dataset.nobleHoverSrc !== hoverSrc) {
          image.removeAttribute('srcset');
          picture.querySelectorAll('source').forEach((source) => source.remove());
          card.dataset.nobleHoverApproved = 'false';
          image.onload = scheduleHoverMedia;
          image.onerror = () => {
            image.dataset.nobleHoverFailedSrc = hoverSrc;
            scheduleHoverMedia();
          };
          image.alt = assignment.alt;
          image.loading = 'lazy';
          image.dataset.nobleHoverSrc = hoverSrc;
          image.src = hoverSrc;
        }
        card.dataset.nobleHoverType = assignment.type;
        card.dataset.nobleHoverApproved = image.complete && image.naturalWidth > 0 &&
          image.dataset.nobleHoverFailedSrc !== hoverSrc ? 'true' : 'false';
        return;
      }

      card.removeAttribute('data-noble-hover-type');
      card.dataset.nobleHoverApproved = 'false';
    });
  };

  let hoverQueued = false;
  const scheduleHoverMedia = () => {
    if (hoverQueued) return;
    hoverQueued = true;
    requestAnimationFrame(() => {
      hoverQueued = false;
      applyHoverMedia();
    });
  };

  new MutationObserver(scheduleHoverMedia).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scheduleHoverMedia);
  scheduleHoverMedia();
})();


(() => {
  if (window.nobleCollectionPhase1A) return;
  window.nobleCollectionPhase1A = true;
  const filesRoot = 'https://cdn.shopify.com/s/files/1/0673/0147/4485/files/';
  const calibration = {
    "frankincense-tallow-face-cream": ["noble-collection-grid-frankincense-tallow-face-cream-pixel-preserved-v1.png?v=1791224120","Frankincense Face Tallow"],
    "radiance-lavender-frankincense-face-cream": ["noble-collection-grid-radiance-lavender-frankincense-face-cream-pixel-preserved-v1.png?v=1791224125","Lavender & Frankincense Face Tallow"],
    "tea-tree-frankincense": ["noble-collection-grid-tea-tree-frankincense-pixel-preserved-v1.png?v=1791224129","Tea Tree & Frankincense Face Tallow"],
    "noble-skin-co-gift-card": ["noble-collection-grid-noble-skin-co-gift-card-pixel-preserved-v1.png?v=1791224134","Noble Skin Co. Gift Card"],
    "baby-balm": ["noble-collection-grid-baby-balm-pixel-preserved-v1.png?v=1791224139","Baby Balm"],
    "sweet-cheeks": ["noble-sweet-cheeks-2oz-correction-source.png?v=1791325925","Sweet Cheeks Diaper Balm"],
    "peppermint-vanilla-whipped-tallow-body-cream": ["noble-collection-grid-peppermint-vanilla-whipped-tallow-body-cream-pixel-preserved-v1.png?v=1791224150","Peppermint Vanilla Body Tallow"],
    "balance-hydrate-toner-for-combination-and-oily-skin": ["noble-collection-grid-balance-hydrate-toner-for-combination-and-oily-skin-pixel-preserved-v1.png?v=1791224155","Facial Tonics / Toners"],
    "vanilla-bean-whipped-tallow-whole-body-cream": ["noble-collection-grid-vanilla-bean-whipped-tallow-whole-body-cream-pixel-preserved-v1.png?v=1791224162","Vanilla Bean Tallow Balm"],
    "rosemary-mint-whole-body-whipped-tallow": ["noble-collection-grid-rosemary-mint-whole-body-whipped-tallow-pixel-preserved-v1.png?v=1791224167","Rosemary Mint Bergamot Body Tallow"],
    "lavender-eucalyptus-whipped-tallow-face-body-cream-v1-copy": ["noble-collection-grid-lavender-eucalyptus-whipped-tallow-face-body-cream-v1-copy-pixel-preserved-v1.png?v=1791224176","Lavender Eucalyptus Body Tallow"],
    "dry-shampoo": ["noble-collection-grid-dry-shampoo-pixel-preserved-v1.png?v=1791224180","Herbal Dry Shampoo – Naturally Fresh (Light & Dark Hair)"],
    "serenity-bath-soak": ["noble-collection-grid-serenity-bath-soak-pixel-preserved-v1.png?v=1791224185","Serenity Herbal Bath Soak"],
    "mineral-sun-stick": ["noble-collection-grid-mineral-sun-stick-pixel-preserved-v1.png?v=1791224190","Mineral Sun Balm"],
    "nourishing-tallow-lip-balm": ["noble-collection-grid-nourishing-tallow-lip-balm-pixel-preserved-v1.png?v=1791224195","Tallow Lip Balm"],
    "rose-lemon-vanilla-face-cream": ["noble-collection-grid-rose-lemon-vanilla-face-cream-pixel-preserved-v1.png?v=1791224200","Rose Lemon Vanilla Face Tallow"],
    "nourish-soothe-eye-balm": ["noble-collection-grid-nourish-soothe-eye-balm-pixel-preserved-v1.png?v=1791224206","Soothe Eye Balm"],
    "orange-chamomile": ["noble-collection-grid-orange-chamomile-pixel-preserved-v1.png?v=1791224210","Orange Chamomile Body Tallow"],
    "bare-unscented-whipped-tallow": ["noble-collection-grid-bare-unscented-whipped-tallow-pixel-preserved-v1.png?v=1791224215","Bare Unscented Face Tallow"],
    "rejuvenating-face-mask": ["noble-collection-grid-rejuvenating-face-mask-pixel-preserved-v1.png?v=1791224221","Rejuvenate Face Mask"],
    "clear-skin-spirulina-face-mask": ["noble-collection-grid-clear-skin-spirulina-face-mask-pixel-preserved-v1.png?v=1791224230","Soothe Face Mask"],
    "clarify-face-mask": ["noble-collection-grid-clarify-face-mask-pixel-preserved-v1.png?v=1791224234","Clarify Face Mask"],
    "clarify-tallow-face-cream": ["noble-collection-grid-clarify-tallow-face-cream-pixel-preserved-v1.png?v=1791224239","Clarify Face Cream"],
    "soothe-tallow-face-cream-for-sensitive-or-reactive-skin": ["noble-collection-grid-soothe-tallow-face-cream-for-sensitive-or-reactive-skin-pixel-preserved-v1.png?v=1791224244","Soothe Face Cream"],
    "tinted-lip-balm-cheek-stain": ["noble-collection-grid-tinted-lip-balm-cheek-stain-pixel-preserved-v1.png?v=1791224249","Tinted Tallow Lip Balm + Cheek Stain"],
    "lip-cuticle-balm": ["noble-collection-grid-lip-cuticle-balm-pixel-preserved-v1.png?v=1791224254","Lip & Cuticle Balm"],
    "intensive-recovery-face-mask": ["noble-collection-grid-intensive-recovery-face-mask-pixel-preserved-v1.png?v=1791224262","Intensive Recovery Face Mask"],
    "rejuvenate-toner": ["noble-collection-grid-rejuvenate-toner-pixel-preserved-v1.png?v=1791224267","Rejuvenate Toner"],
    "soothe-serum": ["noble-collection-grid-soothe-serum-pixel-preserved-v1.png?v=1791224271","Soothe Face Serum"],
    "underarm-scrub": ["noble-collection-grid-underarm-scrub-pixel-preserved-v1.png?v=1791224277","Underarm Detox Scrub"],
    "vanilla-bean-tallow-deodorant": ["noble-collection-grid-vanilla-bean-tallow-deodorant-pixel-preserved-v1.png?v=1791224284","Vanilla Bean Deodorant"],
    "orange-lemongrass-tallow-deodorant": ["noble-collection-grid-orange-lemongrass-tallow-deodorant-pixel-preserved-v1.png?v=1791224290","Orange Lemongrass Deodorant"],
    "geranium-tallow-deodorant": ["noble-collection-grid-geranium-tallow-deodorant-pixel-preserved-v1.png?v=1791224294","Geranium Deodorant"],
    "lavender-tallow-deodorant": ["noble-collection-grid-lavender-tallow-deodorant-pixel-preserved-v1.png?v=1791224300","Lavender Deodorant"],
    "eucalyptus-lemongrass-tallow-deodorant": ["noble-collection-grid-eucalyptus-lemongrass-tallow-deodorant-pixel-preserved-v1.png?v=1791224305","Eucalyptus Lemongrass Deodorant"],
    "ylang-ylang-blue-tansy-tallow-deodorant": ["noble-collection-grid-ylang-ylang-blue-tansy-tallow-deodorant-pixel-preserved-v1.png?v=1791224310","Ylang Ylang Blue Tansy Deodorant"],
    "build-your-daily-ritual": ["noble-collection-grid-build-your-daily-ritual-pixel-preserved-v1.png?v=1791224315","Build Your Ritual Skincare Bundle"],
    "noble-serum-trio": ["noble-collection-grid-noble-serum-trio-pixel-preserved-v1.png?v=1791224321","Face Serum Trio"],
    "noble-mini-toner-trio": ["noble-collection-grid-noble-mini-toner-trio-pixel-preserved-v1.png?v=1791224326","Mini Toner Trio"],
    'glow-up-serum': ["noble-collection-grid-glow-up-serum-pixel-preserved-v1.png?v=1791223210", "Glow Up Serum"],
    'golden-hour-bronzing-serum': ["noble-collection-grid-golden-hour-bronzing-serum-pixel-preserved-v1.png?v=1791223219", "Golden Hour Serum"],
    'soothe-toner': ["noble-collection-grid-soothe-toner-pixel-preserved-v1.png?v=1791223228", "Soothe Toner"],
    'cleansing-oil': ["noble-collection-grid-cleansing-oil-pixel-preserved-v1.png?v=1791223237", "Cleansing Oil"],
    'rejuvenate-tallow-face-cream': ["noble-collection-grid-rejuvenate-tallow-face-cream-pixel-preserved-v1.png?v=1791223242", "Rejuvenate Face Cream"],
    'barrier-rescue-balm': ["noble-collection-grid-barrier-rescue-balm-pixel-preserved-v1.png?v=1791223247", "Barrier Rescue Balm"],
    'rejuvenate-serum': ["noble-collection-grid-rejuvenate-serum-pixel-preserved-v1.png?v=1791223253", "Rejuvenate Face Serum"],
    'orange-vanilla-whipped-tallow-whole-body-cream': ["noble-collection-grid-orange-vanilla-whipped-tallow-whole-body-cream-pixel-preserved-v1.png?v=1791223257", "Orange Vanilla Body Tallow"],
    'eucalyptus-bergamot-tallow-deodorant': ["noble-collection-grid-eucalyptus-bergamot-tallow-deodorant-pixel-preserved-v1.png?v=1791223263", "Eucalyptus Bergamot Deodorant"],
    'eucalyptus-bergamot-tallow-body-cream': ['noble-collection-grid-eucalyptus-bergamot-primary-floor-v2.png?v=1791220732', 'Eucalyptus Bergamot Body Tallow'],
    'antioxidant-repair-balm': ['noble-collection-grid-antioxidant-repair-balm-1oz-5x7.jpg?v=1791215112', 'Antioxidant Repair Balm 1 oz'],
    'clarify-serum': ['noble-collection-grid-clarify-face-serum-0-5oz-5x7.jpg?v=1791215112', 'Clarify Face Serum 0.5 oz'],
    'atlas-cedarwood-bergamot-whipped-tallow-face-body-cream': ['noble-collection-grid-atlas-body-tallow-4oz-5x7.jpg?v=1791215112', 'Atlas Cedarwood Bergamot Body Tallow 4 oz'],

    'clarify-toner': ['noble-collection-grid-clarify-toner-1oz-5x7.jpg?v=1791215112', 'Clarify Toner 1 oz']
  };
  const bodyMerchandisingHandles = new Set([
    "peppermint-vanilla-whipped-tallow-body-cream",
    "vanilla-bean-whipped-tallow-whole-body-cream",
    "rosemary-mint-whole-body-whipped-tallow",
    "orange-vanilla-whipped-tallow-whole-body-cream",
    "lavender-eucalyptus-whipped-tallow-face-body-cream-v1-copy",
    "orange-chamomile",
    "atlas-cedarwood-bergamot-whipped-tallow-face-body-cream",
    "eucalyptus-bergamot-tallow-body-cream"
]);
  const isBodyCollection = /^\/collections\/body\/?$/.test(window.location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/collections\/)/i, ''));
  const applyBodyMerchandisingDefault = (card, handle) => {
    if (!isBodyCollection || !bodyMerchandisingHandles.has(handle)) return;
    const select = card.querySelector('.noble-grid-variant');
    if (!select || select.dataset.nobleBodyMerchandisingDefault) return;
    const fourOz = [...select.options].find((option) => /^4\s*oz(?:\s|$)/i.test(option.textContent.trim()));
    if (!fourOz) return;
    select.dataset.nobleBodyMerchandisingDefault = '4oz';
    if (select.value !== fourOz.value) {
      select.value = fourOz.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };
  const familyPrimary = {
  "frankincense-tallow-face-cream": [
    "noble-collection-grid-frankincense-tallow-face-cream-1oz-merchandising-v1.png?v=1791225606",
    "Frankincense Face Tallow 1 oz"
  ],
  "radiance-lavender-frankincense-face-cream": [
    "noble-collection-grid-radiance-lavender-frankincense-face-cream-1oz-merchandising-v1.png?v=1791225611",
    "Lavender & Frankincense Face Tallow 1 oz"
  ],
  "tea-tree-frankincense": [
    "noble-collection-grid-tea-tree-frankincense-1oz-merchandising-v1.png?v=1791225616",
    "Tea Tree & Frankincense Face Tallow 1 oz"
  ],
  "rose-lemon-vanilla-face-cream": [
    "noble-collection-grid-rose-lemon-vanilla-face-cream-1oz-merchandising-v1.png?v=1791225621",
    "Rose Lemon Vanilla Face Tallow 1 oz"
  ],
  "rejuvenating-face-mask": [
    "noble-collection-grid-rejuvenating-face-mask-1oz-merchandising-v1.png?v=1791225626",
    "Rejuvenate Face Mask 1 oz"
  ],
  "clear-skin-spirulina-face-mask": [
    "noble-collection-grid-clear-skin-spirulina-face-mask-1oz-merchandising-v1.png?v=1791225632",
    "Soothe Face Mask 1 oz"
  ],
  "intensive-recovery-face-mask": [
    "noble-collection-grid-intensive-recovery-face-mask-1oz-merchandising-v1.png?v=1791225637",
    "Intensive Recovery Face Mask 1 oz"
  ],
  "rejuvenate-toner": [
    "noble-collection-grid-rejuvenate-toner-2oz-merchandising-v1.png?v=1791225642",
    "Rejuvenate Toner 2 oz"
  ],
  "soothe-toner": [
    "noble-collection-grid-soothe-toner-2oz-merchandising-v1.png?v=1791225648",
    "Soothe Toner 2 oz"
  ],
  "clarify-toner": [
    "noble-collection-grid-clarify-toner-2oz-merchandising-v1.png?v=1791225653",
    "Clarify Toner 2 oz"
  ]
};
  const familyMerchandisingVariants = {
  "balance-hydrate-toner-for-combination-and-oily-skin": "52020338131125",
  "glow-up-serum": "52493170573493",
  "rose-lemon-vanilla-face-cream": "45316375380149",
  "golden-hour-bronzing-serum": "52791459414197",
  "rejuvenating-face-mask": "51464743583925",
  "clarify-face-mask": "51808475873461",
  "clarify-tallow-face-cream": "51901634248885",
  "rejuvenate-tallow-face-cream": "51901645062325",
  "soothe-tallow-face-cream-for-sensitive-or-reactive-skin": "51916274270389",
  "rejuvenate-toner": "52769192476853",
  "soothe-toner": "52769201225909",
  "clarify-toner": "52769225015477",
  "rejuvenate-serum": "53005549338805",
  "soothe-serum": "53005618053301",
  "clarify-serum": "53005728153781",
  "vanilla-bean-tallow-deodorant": "53103654371509",
  "citrus-vanilla-tallow-deodorant": "53103654437045",
  "orange-lemongrass-tallow-deodorant": "53103654535349",
  "geranium-tallow-deodorant": "53103654633653",
  "lavender-tallow-deodorant": "53103654699189",
  "eucalyptus-bergamot-tallow-deodorant": "53103654797493",
  "eucalyptus-lemongrass-tallow-deodorant": "53103654863029",
  "ylang-ylang-blue-tansy-tallow-deodorant": "53103654961333",
  "frankincense-tallow-face-cream": "44853807218869",
  "radiance-lavender-frankincense-face-cream": "51947905679541",
  "tea-tree-frankincense": "53103549087925",
  "clear-skin-spirulina-face-mask": "51525528354997",
  "intensive-recovery-face-mask": "52763920826549"
};
  const applyFamilyMerchandisingDefault = (card, handle) => {
    if (isBodyCollection) return;
    const variant = familyMerchandisingVariants[handle];
    const select = card.querySelector('.noble-grid-variant');
    if (!variant || !select || select.dataset.nobleFamilyMerchandisingDefault) return;
    const preferred = [...select.options].find((option) => option.value === variant);
    if (!preferred) return;
    select.dataset.nobleFamilyMerchandisingDefault = variant;
    if (preferred.disabled) {
      const add = card.querySelector('.noble-grid-add');
      if (add) {
        const originallyDisabled = add.disabled;
        const syncAvailability = () => { add.disabled = originallyDisabled || Boolean(select.selectedOptions[0]?.disabled); };
        select.addEventListener('change', syncAvailability);
        syncAvailability();
      }
    }
    if (select.value !== variant) {
      select.value = variant;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };
  const scope = '#product-grid .card-wrapper[data-noble-phase1a]';
  const style = document.createElement('style');
  style.textContent = `
    ${scope} { display: flex !important; flex-direction: column !important; height: auto !important; width: 100%; }
    ${scope} > .card { flex: 0 0 auto; transform: none !important; }
    ${scope} .card__media { display: block; padding: 0 !important; width: 100%; transform: none !important; }
    ${scope} .card__media > .media {
      position: relative !important; width: 100% !important; height: auto !important;
      min-height: 0 !important; padding: 0 !important; aspect-ratio: 5 / 7 !important;
      overflow: hidden; transform: none !important; transition: none !important; background: #fff;
    }
    ${scope} .card__media > .media > picture,
    ${scope}:hover .card__media > .media > picture {
      position: absolute !important; inset: 0 !important; display: block !important;
      width: 100% !important; height: 100% !important; margin: 0 !important;
      padding: 0 !important; transform: none !important; visibility: visible !important;
      transition: opacity 180ms ease !important; overflow: hidden;
    }
    ${scope} .card__media > .media > picture > img,
    ${scope}:hover .card__media > .media > picture > img {
      position: absolute !important; inset: 0 !important; display: block !important;
      width: 100% !important; height: 100% !important; max-width: none !important;
      margin: 0 !important; padding: 0 !important; transform: none !important;
      opacity: 1 !important; visibility: visible !important; transition: none !important;
    }
    ${scope} .card__media > .media > picture:first-of-type,
    ${scope}:hover .card__media > .media > picture:first-of-type { opacity: 1 !important; z-index: 0; }
    ${scope} .card__media > .media > picture:first-of-type > img {
      object-fit: contain !important; object-position: center center !important;
    }
    ${scope} .card__media > .media > picture:nth-of-type(2) { opacity: 0 !important; z-index: 1; pointer-events: none !important; }
    ${scope} .card__media > .media > picture:nth-of-type(2) > img {
      object-fit: cover !important; object-position: center center !important;
    }
    ${scope} > .card-information { display: block !important; flex: 0 0 auto !important; padding-top: 0 !important; }
    ${scope} .card-information__wrapper {
      display: grid !important; grid-template-columns: minmax(0, 1fr);
      grid-template-rows: 2.6em 22px 20px 104px;
      gap: 6px !important; padding: 12px 0 0 !important; width: 100%;
      font-size: 14px; line-height: 1.3;
    }
    ${scope} .card-information__wrapper > * { margin: 0 !important; min-width: 0; }
    ${scope} .card-information__text {
      grid-row: 1; display: -webkit-box !important; -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; overflow: hidden; height: 2.6em !important;
      min-height: 0 !important; padding: 0 !important; font-size: inherit; line-height: 1.3 !important;
    }
    ${scope} .noble-grid-price { grid-row: 2; display: block !important; min-height: 0 !important; }
    ${scope} .noble-grid-price .price { margin: 0 !important; min-height: 0 !important; line-height: 1.4; }
    ${scope} .noble-card-rating, ${scope} .noble-phase1a-review {
      grid-row: 3; display: flex !important; align-items: center; min-height: 0 !important; height: 20px;
    }
    ${scope} .noble-phase1a-review > * { margin: 0 !important; }
    ${scope} .noble-grid-purchase > .noble-grid-add { margin-top: 56px !important; }
    ${scope} .noble-grid-purchase { grid-row: 4; display: block !important; margin: 0 !important; }
    ${scope} .noble-grid-form { display: grid; grid-template-columns: minmax(0, 1fr); grid-template-rows: 46px 48px; gap: 10px; margin: 0; }
    ${scope} .noble-grid-variant { grid-row: 1; height: 46px; margin: 0 !important; }
    ${scope} .noble-grid-add { grid-row: 2; height: 48px; min-height: 48px; margin: 0 !important; }
    ${scope} .card-information__wrapper > .price,
    ${scope} .card-information__wrapper > .loox-rating,
    ${scope} .card-information__top:empty { display: none !important; }
    @media (hover: hover) and (pointer: fine) {
      ${scope}[data-noble-hover-approved="true"]:hover .card__media > .media > picture:nth-of-type(2) { opacity: 1 !important; }
    }
    @media (prefers-reduced-motion: reduce) {
      ${scope} .card__media > .media > picture { transition: none !important; }
    }
  `;
  document.head.appendChild(style);
  const normalizePrimary = (card, media) => {
    const picture = media.querySelector(':scope > picture:first-of-type');
    const source = picture?.querySelector('img');
    if (!source || picture.dataset.noblePackshot) return;
    picture.dataset.noblePackshot = 'pending';
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
        const ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(image, 0, 0);
        const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const w = canvas.width, h = canvas.height;
        const corners = [0, w - 1, (h - 1) * w, h * w - 1];
        const bg = [0, 1, 2].map(k => corners.reduce((sum, p) => sum + data[p * 4 + k], 0) / 4);
        const uniform = corners.every(p => bg.every((v, k) => Math.abs(v - data[p * 4 + k]) < 22));
        let left = w, right = 0, top = h, bottom = 0;
        if (uniform && Math.min(...bg) > 175) {
          for (let y = 0; y < h; y++) {
            let count = 0, lo = w, hi = 0;
            for (let x = 0; x < w; x++) {
              const p = (y * w + x) * 4;
              if (data[p + 3] > 32 && bg.some((v, k) => Math.abs(v - data[p + k]) > 24)) {
                count++; lo = Math.min(lo, x); hi = Math.max(hi, x);
              }
            }
            if (count >= 2) {
              left = Math.min(left, lo); right = Math.max(right, hi);
              top = Math.min(top, y); bottom = Math.max(bottom, y);
            }
          }
        }
        if (right <= left || bottom <= top || !uniform || Math.min(...bg) <= 175) {
          card.dataset.noblePackshotException = 'source-composition';
          picture.dataset.noblePackshot = 'original';
          return;
        }
        const packageWidth = right - left + 1;
        const packageHeight = bottom - top + 1;
        const ratio = packageWidth / packageHeight;
        const packageLeft = left, packageTop = top, packageBottom = bottom + 1;
        const margin = Math.ceil(Math.max(w, h) * .04);
        left = Math.max(0, left - margin); top = Math.max(0, top - margin);
        right = Math.min(w, right + margin + 1); bottom = Math.min(h, bottom + margin + 1);
        const sw = right - left, sh = bottom - top;
        const output = document.createElement('canvas');
        output.width = 1000; output.height = 1400;
        const out = output.getContext('2d');
        out.fillStyle = 'rgb(' + bg.join(',') + ')';
        out.fillRect(0, 0, 1000, 1400);
        const limits = ratio < .65 ? [580, 1000] : ratio < 1.65 ? [700, 780] : [800, 650];
        const floor = 1210;
        const desired = Math.min(limits[0] / packageWidth, limits[1] / packageHeight);
        const safe = Math.min(900 / sw, (floor - 100) / (packageBottom - top), 130 / Math.max(1, bottom - packageBottom));
        const scale = Math.min(desired, safe);
        const dw = sw * scale, dh = sh * scale;
        const x = (1000 - packageWidth * scale) / 2 - (packageLeft - left) * scale;
        const y = floor - (packageBottom - top) * scale;
        out.drawImage(image, left, top, sw, sh, x, y, dw, dh);
        picture.querySelectorAll('source').forEach(el => el.remove());
        source.removeAttribute('srcset');
        source.src = output.toDataURL('image/png');
        picture.dataset.noblePackshot = 'normalized';
      } catch {
        card.dataset.noblePackshotException = 'unreadable-source';
        picture.dataset.noblePackshot = 'original';
      }
    };
    image.onerror = () => { card.dataset.noblePackshotException = 'unreadable-source'; picture.dataset.noblePackshot = 'original'; };
    image.src = source.currentSrc || source.src;
  };
  const apply = () => {
    document.querySelectorAll('#product-grid .card-wrapper').forEach((card) => {
      const href = card.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
      const handle = href.split('/products/')[1]?.split(/[?#/]/)[0];
      const primary = (!isBodyCollection && familyPrimary[handle]) || calibration[handle];

      const media = card.querySelector('.card__media > .media');
      if (!media) return;
      if (primary && !media.querySelector('picture[data-noble-phase1a-primary]')) {
        const picture = document.createElement('picture');
        picture.dataset.noblePhase1aPrimary = 'true';
        const image = document.createElement('img');
        image.src = filesRoot + primary[0];
        image.alt = primary[1];
        image.width = 1000;
        image.height = 1400;
        image.loading = 'lazy';
        image.decoding = 'async';
        picture.appendChild(image);
        const previous = media.querySelector(':scope > picture:first-of-type');
        if (previous) previous.replaceWith(picture);
        else media.prepend(picture);
      }
      if (!primary) normalizePrimary(card, media);
      applyBodyMerchandisingDefault(card, handle);
      applyFamilyMerchandisingDefault(card, handle);
      if (card.dataset.noblePhase1a) return;
      card.dataset.noblePhase1a = handle;
      const body = card.querySelector('.card-information__wrapper');
      const noReviews = card.querySelector('.noble-grid-no-reviews');
      if (body && !body.querySelector(':scope > .noble-card-rating')) {
        const reviews = document.createElement('div');
        reviews.className = 'noble-phase1a-review';
        if (noReviews) reviews.appendChild(noReviews);
        body.insertBefore(reviews, body.querySelector('.noble-grid-purchase'));
      }
      if (handle === 'citrus-vanilla-tallow-deodorant') {
        const select = card.querySelector('.noble-grid-variant');
        const fullSize = select && [...select.options].find((option) => /(?:^|\s)3\s*oz(?:\s|$)/i.test(option.textContent));
        if (fullSize) {
          select.value = fullSize.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; apply(); });
  };
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
  schedule();
})();

(() => {
  if (!document.querySelector('#product-grid') || document.getElementById('noble-card-control-refinements')) return;
  const style = document.createElement('style');
  style.id = 'noble-card-control-refinements';
  style.textContent = `
    #product-grid .card-wrapper .noble-grid-variant {
      -webkit-appearance: none !important;
      appearance: none !important;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' fill='none' stroke='%2309243a' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") !important;
      background-repeat: no-repeat !important;
      background-position: right 12px center !important;
      background-size: 12px 8px !important;
      padding-right: 36px !important;
    }
    #product-grid .card-wrapper .card__media::before,
    #product-grid .card-wrapper .card__media::after,
    #product-grid .card-wrapper .card__media .media::before,
    #product-grid .card-wrapper .card__media .media::after,
    #product-grid .card-wrapper .card__media picture::before,
    #product-grid .card-wrapper .card__media picture::after {
      content: none !important;
      display: none !important;
      animation: none !important;
    }
  `;
  document.head.appendChild(style);
})();

(() => {
  const grid = document.querySelector('#product-grid');
  if (!grid || document.getElementById('noble-face-education-styles')) return;
  const labels = {
  "antioxidant-repair-balm": "ALL SKIN TYPES • BRIGHTEN + RENEW",
  "rejuvenate-tallow-face-cream": "DRY + MATURE",
  "soothe-tallow-face-cream-for-sensitive-or-reactive-skin": "SENSITIVE + REACTIVE",
  "clarify-tallow-face-cream": "CONGESTED + COMBINATION",
  "barrier-rescue-balm": "ECZEMA-PRONE + VERY DRY",
  "frankincense-tallow-face-cream": "ALL SKIN TYPES",
  "radiance-lavender-frankincense-face-cream": "ALL SKIN TYPES",
  "tea-tree-frankincense": "ACNE-PRONE + CONGESTED",
  "bare-unscented-whipped-tallow": "SENSITIVE + ALL SKIN TYPES",
  "rose-lemon-vanilla-face-cream": "DRY + DULL",
  "rejuvenate-serum": "DRY + MATURE",
  "soothe-serum": "SENSITIVE + REACTIVE",
  "clarify-serum": "CONGESTED + COMBINATION",
  "rejuvenate-toner": "DRY + MATURE",
  "soothe-toner": "SENSITIVE + REACTIVE",
  "clarify-toner": "CONGESTED + COMBINATION",
  "rejuvenating-face-mask": "DRY + MATURE",
  "clear-skin-spirulina-face-mask": "SENSITIVE + REACTIVE",
  "clarify-face-mask": "CONGESTED + COMBINATION",
  "nourish-soothe-eye-balm": "SENSITIVE + DELICATE EYE AREA",
  "cleansing-oil": "NORMAL + DRY • GENTLE CLEANSING",
  "peppermint-vanilla-whipped-tallow-body-cream": "DRY SKIN • RICH MOISTURE",
  "vanilla-bean-whipped-tallow-whole-body-cream": "DRY SKIN • RICH MOISTURE",
  "rosemary-mint-whole-body-whipped-tallow": "DRY SKIN • RICH MOISTURE",
  "orange-vanilla-whipped-tallow-whole-body-cream": "DRY SKIN • RICH MOISTURE",
  "lavender-eucalyptus-whipped-tallow-face-body-cream-v1-copy": "DRY SKIN • RICH MOISTURE",
  "orange-chamomile": "DRY SKIN • RICH MOISTURE",
  "atlas-cedarwood-bergamot-whipped-tallow-face-body-cream": "DRY SKIN • RICH MOISTURE",
  "eucalyptus-bergamot-tallow-body-cream": "DRY SKIN • RICH MOISTURE",
  "vanilla-bean-tallow-deodorant": "ALUMINUM-FREE • DAILY ODOR CARE",
  "citrus-vanilla-tallow-deodorant": "ALUMINUM-FREE • DAILY ODOR CARE",
  "orange-lemongrass-tallow-deodorant": "ALUMINUM-FREE • DAILY ODOR CARE",
  "geranium-tallow-deodorant": "ALUMINUM-FREE • DAILY ODOR CARE",
  "lavender-tallow-deodorant": "ALUMINUM-FREE • DAILY ODOR CARE",
  "eucalyptus-bergamot-tallow-deodorant": "ALUMINUM-FREE • DAILY ODOR CARE",
  "eucalyptus-lemongrass-tallow-deodorant": "ALUMINUM-FREE • DAILY ODOR CARE",
  "ylang-ylang-blue-tansy-tallow-deodorant": "ALUMINUM-FREE • DAILY ODOR CARE"
};
  const style = document.createElement('style');
  style.id = 'noble-face-education-styles';
  style.textContent = `
    #product-grid .card-wrapper[data-noble-phase1a] .card-information__wrapper {
      grid-template-rows: 28px 2.6em 22px 20px 104px !important;
    }
    #product-grid .card-wrapper[data-noble-phase1a] .noble-face-education {
      grid-row: 1;
      display: flex;
      align-items: flex-end;
      height: 28px;
      color: #194f47;
      font-family: var(--font-body-family);
      font-size: 10px;
      font-weight: 600;
      line-height: 14px;
      letter-spacing: .12em;
      text-transform: uppercase;
      margin: 0;
    }
    #product-grid .card-wrapper[data-noble-phase1a] .noble-face-education > span {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    #product-grid .card-wrapper[data-noble-phase1a] .card-information__text { grid-row: 2; }
    #product-grid .card-wrapper[data-noble-phase1a] .noble-grid-price { grid-row: 3; }
    #product-grid .card-wrapper[data-noble-phase1a] .noble-card-rating,
    #product-grid .card-wrapper[data-noble-phase1a] .noble-phase1a-review { grid-row: 4; }
    #product-grid .card-wrapper[data-noble-phase1a] .noble-grid-purchase { grid-row: 5; }
  `;
  document.head.appendChild(style);
  const apply = () => {
    document.querySelectorAll('#product-grid .card-wrapper').forEach((card) => {
      const body = card.querySelector('.card-information__wrapper');
      const title = body?.querySelector('.card-information__text');
      if (!title || body.querySelector(':scope > .noble-face-education')) return;
      const href = card.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
      const handle = href.split('/products/')[1]?.split(/[?#/]/)[0];
      const label = document.createElement('div');
      label.className = 'noble-face-education';
      const text = labels[handle];
      if (text) {
        const span = document.createElement('span');
        span.textContent = text;
        label.appendChild(span);
      } else {
        label.setAttribute('aria-hidden', 'true');
      }
      body.insertBefore(label, title);
    });
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; apply(); });
  };
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
  schedule();
})();

/* Selected-variant prices use the same option submitted by the collection ADD form. */
(() => {
  const selector = '#product-grid[data-noble-collection] .noble-grid-variant';
  const money = (value) => {
    const text = document.createElement('span');
    text.textContent = value;
    return '<price-money><bdi>' + text.innerHTML + '</bdi></price-money>';
  };
  const sync = (select) => {
    const option = select.selectedOptions[0];
    const card = select.closest('.card-wrapper');
    const price = card?.querySelector('.noble-grid-price .price');
    if (!option || !price || !option.dataset.price) return;
    const signature = [option.value, option.dataset.price, option.dataset.compare || '', option.disabled].join('|');
    if (price.dataset.nobleSelectedVariantPrice === signature) return;
    price.dataset.nobleSelectedVariantPrice = signature;
    price.querySelectorAll('.price__regular .price-item, .price__sale .price-item--sale').forEach((amount) => {
      amount.innerHTML = money(option.dataset.price);
    });
    price.querySelectorAll('.price__compare .price-item').forEach((amount) => {
      amount.innerHTML = money(option.dataset.compare || option.dataset.price);
    });
    price.classList.toggle('price--on-sale', Boolean(option.dataset.compare));
    const form = select.closest('form');
    const add = form?.querySelector('[type="submit"]');
    if (add) add.disabled = option.disabled;
  };
  const picturedDefaults = {
    'antioxidant-repair-balm': '1',
    'eucalyptus-bergamot-tallow-body-cream': '4',
    'atlas-cedarwood-bergamot-whipped-tallow-face-body-cream': '4',
    'orange-chamomile': '4'
  };
  const initialize = (select) => {
    if (!select.dataset.noblePicturedDefaultChecked) {
      select.dataset.noblePicturedDefaultChecked = 'true';
      const href = select.closest('.card-wrapper')?.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
      const handle = href.split('/products/')[1]?.split(/[?#/]/)[0];
      const size = picturedDefaults[handle];
      const option = size && [...select.options].find((item) => new RegExp('^' + size + '\\s*oz(?:\\s|$)', 'i').test(item.textContent.trim()));
      if (option && select.value !== option.value) {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    sync(select);
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      document.querySelectorAll(selector).forEach(initialize);
    });
  };
  document.addEventListener('change', (event) => {
    if (event.target.matches?.(selector)) sync(event.target);
  });
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
})();

} else {
(() => {
  if (window.nobleShopAllCadence) return;
  window.nobleShopAllCadence = true;

  const positionRotations = {
    4: [4, 1, 3, 2],
    3: [3, 1, 2],
    2: [2, 1],
    1: [1]
  };
  const curatedShopAllHandles = [
    'antioxidant-repair-balm',
    'clarify-serum',
    'eucalyptus-bergamot-tallow-body-cream',
    'citrus-vanilla-tallow-deodorant',
    'soothe-toner',
    'rejuvenate-tallow-face-cream',
    'cleansing-oil',
    'barrier-rescue-balm',
    'rejuvenate-serum',
    'orange-vanilla-whipped-tallow-whole-body-cream',
    'eucalyptus-bergamot-tallow-deodorant',
    'clarify-toner',
    'soothe-tallow-face-cream-for-sensitive-or-reactive-skin',
    'build-your-daily-ritual',
    'rejuvenate-toner',
    'soothe-serum',
    'lavender-eucalyptus-whipped-tallow-face-body-cream-v1-copy',
    'geranium-tallow-deodorant',
    'clarify-face-mask',
    'rose-lemon-vanilla-face-cream',
    'noble-mini-toner-trio',
    'nourish-soothe-eye-balm',
    'atlas-cedarwood-bergamot-whipped-tallow-face-body-cream',
    'lavender-tallow-deodorant',
    'clarify-tallow-face-cream',
    'rejuvenating-face-mask',
    'glow-up-serum',
    'orange-chamomile',
    'eucalyptus-lemongrass-tallow-deodorant',
    'balance-hydrate-toner-for-combination-and-oily-skin',
    'bare-unscented-whipped-tallow',
    'noble-serum-trio'
  ];
  const productHandle = (item) => {
    const href = item.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
    return href.split('/products/')[1]?.split(/[?#/]/)[0] || '';
  };
  let queued = false;

  const placeEditorials = () => {
    queued = false;
    const grid = document.querySelector('#product-grid[data-noble-collection]');
    if (!grid) return;

    const children = [...grid.children].filter((item) => item.tagName === 'LI');
    const editorials = children.filter((item) => item.classList.contains('noble-collection-editorial'));
    let products = children.filter((item) => !item.classList.contains('noble-collection-editorial'));

    if (grid.dataset.nobleCollection === 'all') {
      const priority = new Map(curatedShopAllHandles.map((handle, index) => [handle, index]));
      const originalOrder = new Map(products.map((product, index) => [product, index]));
      const orderedProducts = [...products].sort((a, b) => {
        const aPriority = priority.get(productHandle(a));
        const bPriority = priority.get(productHandle(b));
        if (aPriority !== undefined && bPriority !== undefined) return aPriority - bPriority;
        if (aPriority !== undefined) return -1;
        if (bPriority !== undefined) return 1;
        return originalOrder.get(a) - originalOrder.get(b);
      });

      if (orderedProducts.some((product, index) => product !== products[index])) {
        orderedProducts.forEach((product) => grid.appendChild(product));
        products = orderedProducts;
      }
    }

    grid.classList.toggle('noble-shop-all-cadence', editorials.length > 0);
    if (!editorials.length || !products.length) return;

    // Measure the collection's rendered columns instead of assuming a viewport
    // breakpoint. The filter sidebar can reduce a nominal three-column tablet
    // grid to two columns, and the editorial must still occupy one product cell.
    editorials.forEach((editorial) => {
      editorial.hidden = true;
      editorial.style.display = 'none';
      editorial.style.setProperty('grid-column', 'auto', 'important');
      editorial.style.removeProperty('flex-basis');
      editorial.style.removeProperty('width');
      editorial.style.removeProperty('max-width');
      editorial.style.removeProperty('margin-inline-start');
      editorial.style.removeProperty('margin-inline-end');
    });

    const firstRowTop = Math.round(products[0].getBoundingClientRect().top);
    const measuredColumns = Math.max(1, products.filter((product) => (
      Math.abs(Math.round(product.getBoundingClientRect().top) - firstRowTop) <= 2
    )).length);
    const firstPass = grid.dataset.nobleEditorialFirstPass === 'true';
    const cellWidth = products[0].getBoundingClientRect().width;
    const columnGap = parseFloat(getComputedStyle(grid).columnGap) || 0;
    const columns = firstPass ? Math.max(1, Math.round((grid.getBoundingClientRect().width + columnGap) / (cellWidth + columnGap))) : measuredColumns;
    const positions = positionRotations[columns] || Array.from({ length: columns }, (_, index) => index + 1);
    const productsPerEditorialCycle = columns * 2 - 1;
    const productCellWidth = `${products[0].getBoundingClientRect().width}px`;
    const photoPositions = {"rollout_serum_use":"40% center","editorial_serum_body":"center","rollout_toner_prepare":"center","rollout_mask_pair":"center","editorial_eye_soothe":"center","rollout_face_ritual":"center","rollout_face_soothe":"40% center","rollout_face_rejuvenate":"center","editorial_face_discovery":"center","rollout_body_tallow":"center","rollout_body_barrier":"center","rollout_body_family":"40% center","editorial_body_refresh":"center","rollout_deodorant_use":"center","editorial_deodorant_moisture":"center"};
    if (firstPass) editorials.forEach(editorial => {
      const headingId = editorial.querySelector('.noble-collection-editorial__title')?.id || '';
      editorial.dataset.noblePhotoPosition = photoPositions[headingId.replace('Editorial-', '')] || 'center';
    });
    if (firstPass) {
      const editorialOrder = Object.keys(photoPositions);
      editorials.sort((a, b) => editorialOrder.indexOf((a.querySelector('.noble-collection-editorial__title')?.id || '').replace('Editorial-', '')) - editorialOrder.indexOf((b.querySelector('.noble-collection-editorial__title')?.id || '').replace('Editorial-', '')));
    }
    const productCardHeight = Math.max(...products.map(product => product.querySelector('.card-wrapper')?.getBoundingClientRect().height || 0));
    const serumPair = firstPass && grid.dataset.nobleCollection === 'serums' && products.length === 6;
    const tonerRow = firstPass && grid.dataset.nobleCollection === 'toners' && products.length === 3;
    const eyePair = firstPass && grid.dataset.nobleCollection === 'eyes' && products.length === 1;

    for (let index = editorials.length - 1; index >= 0; index -= 1) {
      const editorial = editorials[index];
      let editorialColumn = positions[index % positions.length];
      const intendedAfterProduct = index * productsPerEditorialCycle + columns + editorialColumn - 1;
      let afterProduct = firstPass && index === 0 && (products.length <= 4 || (products.length >= columns && products.length < productsPerEditorialCycle)) ? products.length : intendedAfterProduct;
      if (serumPair) {
        afterProduct = index < 2 ? (index + 1) * 3 : 0;
        editorialColumn = ((afterProduct + index) % columns) + 1;
      } else if (tonerRow || eyePair) {
        afterProduct = index === 0 ? products.length : 0;
        editorialColumn = (products.length % columns) + 1;
      }
      const anchor = products[afterProduct - 1];

      const completeEditorialCycle = products.length >= (index + 1) * productsPerEditorialCycle;
      if (!anchor || (!firstPass && !completeEditorialCycle)) {
        editorial.hidden = true;
        editorial.style.display = 'none';
        continue;
      }

      editorial.hidden = false;
      editorial.style.removeProperty('display');
      editorial.dataset.nobleAfterProduct = String(afterProduct);
      editorial.dataset.nobleEditorialColumn = String(editorialColumn);
      editorial.style.flexBasis = productCellWidth;
      editorial.style.width = productCellWidth;
      editorial.style.maxWidth = productCellWidth;
      if (firstPass) {
        if (!tonerRow && !eyePair && products.length <= 4) {
          editorial.style.marginInlineEnd = `${(columns - 1) * (cellWidth + columnGap)}px`;
          editorial.style.setProperty('grid-column', '1', 'important');
        } else if (!serumPair && !tonerRow && !eyePair && index === 0 && afterProduct < intendedAfterProduct) {
          editorial.style.marginInlineStart = `${(intendedAfterProduct - afterProduct) * (cellWidth + columnGap)}px`;
        }
        editorial.style.setProperty('--noble-cross-sell-height', `${productCardHeight}px`);
        editorial.querySelector('.noble-collection-editorial__image')?.style.setProperty('object-position', editorial.dataset.noblePhotoPosition || 'center');
      }
      if (anchor.nextElementSibling !== editorial) anchor.after(editorial);
    }
  };

  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(placeEditorials);
  };

  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  schedule();
})();

(() => {
  if (window.nobleCollectionHoverMedia) return;
  window.nobleCollectionHoverMedia = true;

  const primaryScaleOverrides = {
    'antioxidant-repair-balm': 1.45,
    'clarify-serum': 1.5,
    'eucalyptus-bergamot-tallow-body-cream': 1.8,
    'citrus-vanilla-tallow-deodorant': 1.5,
    'soothe-toner': 1.5,
    'rejuvenate-tallow-face-cream': 2.1,
    'cleansing-oil': 1.4,
    'barrier-rescue-balm': 2.1,
    'rejuvenate-serum': 1.5,
    'orange-vanilla-whipped-tallow-whole-body-cream': 1.8,
    'eucalyptus-bergamot-tallow-deodorant': 1.5,
    'clarify-toner': 1.5,
    'soothe-tallow-face-cream-for-sensitive-or-reactive-skin': 2.1,
    'rejuvenate-toner': 1.5,
    'soothe-serum': 1.5,
    'lavender-eucalyptus-whipped-tallow-face-body-cream-v1-copy': 1.8,
    'geranium-tallow-deodorant': 1.5,
    'eucalyptus-lemongrass-tallow-deodorant': 1.5,
    'lavender-tallow-deodorant': 1.5,
    'orange-lemongrass-tallow-deodorant': 1.5,
    'vanilla-bean-tallow-deodorant': 1.5,
    'ylang-ylang-blue-tansy-tallow-deodorant': 1.5
  };
  const primaryShiftOverrides = {
    'antioxidant-repair-balm': '0%',
    'clarify-serum': '5%',
    'eucalyptus-bergamot-tallow-body-cream': '10%',
    'citrus-vanilla-tallow-deodorant': '6%',
    'soothe-toner': '5%',
    'rejuvenate-tallow-face-cream': '12%',
    'cleansing-oil': '5%',
    'barrier-rescue-balm': '12%',
    'rejuvenate-serum': '5%',
    'orange-vanilla-whipped-tallow-whole-body-cream': '10%',
    'eucalyptus-bergamot-tallow-deodorant': '6%',
    'clarify-toner': '5%',
    'soothe-tallow-face-cream-for-sensitive-or-reactive-skin': '12%',
    'rejuvenate-toner': '5%',
    'soothe-serum': '5%',
    'lavender-eucalyptus-whipped-tallow-face-body-cream-v1-copy': '10%',
    'geranium-tallow-deodorant': '6%',
    'eucalyptus-lemongrass-tallow-deodorant': '6%',
    'lavender-tallow-deodorant': '6%',
    'orange-lemongrass-tallow-deodorant': '6%',
    'vanilla-bean-tallow-deodorant': '6%',
    'ylang-ylang-blue-tansy-tallow-deodorant': '6%'
  };

  const style = document.createElement('style');
  style.textContent = `
    .product-grid > .flex-grid__item:not(.noble-collection-editorial) {
      align-self: stretch;
      display: flex;
    }
    .product-grid .card-wrapper.noble-purchase-prototype {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
    }
    .product-grid .card-wrapper.noble-purchase-prototype .card__media,
    .product-grid .card-wrapper.noble-purchase-prototype .card__media .media {
      width: 100%;
    }
    .product-grid .card-wrapper.noble-purchase-prototype .card__media .media {
      padding-bottom: 120% !important;
    }
    .product-grid .card-wrapper.noble-purchase-prototype .card__media .media > picture:first-of-type {
      transform: translateY(var(--noble-primary-shift, 0%)) scale(var(--noble-primary-scale, 1.42)) !important;
      transform-origin: center bottom !important;
    }
    .product-grid .card-wrapper.noble-purchase-prototype .card__media .media > picture:first-of-type > img {
      object-fit: contain !important;
      object-position: center bottom !important;
      transform: none !important;
    }
    .product-grid .card-wrapper.noble-purchase-prototype .card-information,
    .product-grid .card-wrapper.noble-purchase-prototype .card-information__wrapper {
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      width: 100%;
    }
    .product-grid .card-wrapper.noble-purchase-prototype .card-information__text {
      min-height: 4.8em;
    }
    .product-grid .card-wrapper.noble-purchase-prototype .noble-grid-price {
      display: flex;
      min-height: 2.75em;
      align-items: flex-start;
    }
    .product-grid .card-wrapper.noble-purchase-prototype .noble-card-rating {
      min-height: 1.5rem;
    }
    .product-grid .card-wrapper.noble-purchase-prototype .noble-grid-purchase {
      margin-top: auto;
    }
    .card__media .media > picture:nth-of-type(2) {
      position: absolute !important;
      inset: 0 !important;
      display: block !important;
      width: 100% !important;
      height: 100% !important;
      overflow: hidden !important;
      background: inherit;
    }
    .card-wrapper:not([data-noble-hover-approved="true"]) .card__media .media > picture:nth-of-type(2) {
      display: none !important;
    }
    .card-wrapper[data-noble-hover-approved="false"] .card__media .media > picture:first-of-type,
    .card-wrapper[data-noble-hover-approved="false"] .card__media .media > picture:first-of-type > img,
    .card-wrapper[data-noble-hover-approved="false"]:hover .card__media .media > picture:first-of-type,
    .card-wrapper[data-noble-hover-approved="false"]:hover .card__media .media > picture:first-of-type > img {
      display: block !important;
      opacity: 1 !important;
      visibility: visible !important;
    }
    .card__media .media > picture:nth-of-type(2) > img {
      position: absolute !important;
      inset: 0 !important;
      display: block !important;
      width: 100% !important;
      height: 100% !important;
      object-position: center center !important;
    }
    .card-wrapper[data-noble-hover-type="lifestyle"] .card__media .media > picture:nth-of-type(2) > img,
    .card-wrapper[data-noble-hover-type="application"] .card__media .media > picture:nth-of-type(2) > img,
    .card-wrapper[data-noble-hover-type="texture"] .card__media .media > picture:nth-of-type(2) > img {
      object-fit: cover !important;
    }
    .card-wrapper[data-noble-hover-type="detail"] .card__media .media > picture:nth-of-type(2) > img,
    .card-wrapper[data-noble-hover-type="fallback"] .card__media .media > picture:nth-of-type(2) > img {
      object-fit: contain !important;
    }
    @media (max-width: 749px), (hover: none), (pointer: coarse) {
      .card__media .media > picture:nth-of-type(2) {
        display: none !important;
      }
      .card-wrapper .card__media .media > picture:first-of-type,
      .card-wrapper .card__media .media > picture:first-of-type > img {
        display: block !important;
        opacity: 1 !important;
        visibility: visible !important;
      }
    }
  `;
  document.head.appendChild(style);

  const handleFromCard = (card) => {
    const href = card.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
    return href.split('/products/')[1]?.split(/[?#/]/)[0] || '';
  };

  const applyHoverMedia = () => {
    document.querySelectorAll('.product-grid .card-wrapper').forEach((card) => {
      card.classList.add('noble-purchase-prototype');
      const handle = handleFromCard(card);
      card.style.setProperty('--noble-primary-scale', String(primaryScaleOverrides[handle] || 1.42));
      card.style.setProperty('--noble-primary-shift', primaryShiftOverrides[handle] || '0%');
      const image = card.querySelector('.card__media .media > picture:nth-of-type(2) img');
      card.dataset.nobleHoverApproved = image ? 'true' : 'false';
      card.dataset.nobleHoverType = 'detail';
    });
  };

  let hoverQueued = false;
  const scheduleHoverMedia = () => {
    if (hoverQueued) return;
    hoverQueued = true;
    requestAnimationFrame(() => {
      hoverQueued = false;
      applyHoverMedia();
    });
  };

  new MutationObserver(scheduleHoverMedia).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scheduleHoverMedia);
  scheduleHoverMedia();
})();


(() => {
  if (window.nobleCollectionPhase1A) return;
  window.nobleCollectionPhase1A = true;
  const bodyMerchandisingHandles = new Set([
    "peppermint-vanilla-whipped-tallow-body-cream",
    "vanilla-bean-whipped-tallow-whole-body-cream",
    "rosemary-mint-whole-body-whipped-tallow",
    "orange-vanilla-whipped-tallow-whole-body-cream",
    "lavender-eucalyptus-whipped-tallow-face-body-cream-v1-copy",
    "orange-chamomile",
    "atlas-cedarwood-bergamot-whipped-tallow-face-body-cream",
    "eucalyptus-bergamot-tallow-body-cream"
]);
  const isBodyCollection = /^\/collections\/body\/?$/.test(window.location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/collections\/)/i, ''));
  const applyBodyMerchandisingDefault = (card, handle) => {
    if (!isBodyCollection || !bodyMerchandisingHandles.has(handle)) return;
    const select = card.querySelector('.noble-grid-variant');
    if (!select || select.dataset.nobleBodyMerchandisingDefault) return;
    const fourOz = [...select.options].find((option) => /^4\s*oz(?:\s|$)/i.test(option.textContent.trim()));
    if (!fourOz) return;
    select.dataset.nobleBodyMerchandisingDefault = '4oz';
    if (select.value !== fourOz.value) {
      select.value = fourOz.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };
  const familyMerchandisingVariants = {
  "balance-hydrate-toner-for-combination-and-oily-skin": "52020338131125",
  "glow-up-serum": "52493170573493",
  "rose-lemon-vanilla-face-cream": "45316375380149",
  "golden-hour-bronzing-serum": "52791459414197",
  "rejuvenating-face-mask": "51464743583925",
  "clarify-face-mask": "51808475873461",
  "clarify-tallow-face-cream": "51901634248885",
  "rejuvenate-tallow-face-cream": "51901645062325",
  "soothe-tallow-face-cream-for-sensitive-or-reactive-skin": "51916274270389",
  "rejuvenate-toner": "52769192476853",
  "soothe-toner": "52769201225909",
  "clarify-toner": "52769225015477",
  "rejuvenate-serum": "53005549338805",
  "soothe-serum": "53005618053301",
  "clarify-serum": "53005728153781",
  "vanilla-bean-tallow-deodorant": "53103654371509",
  "citrus-vanilla-tallow-deodorant": "53103654437045",
  "orange-lemongrass-tallow-deodorant": "53103654535349",
  "geranium-tallow-deodorant": "53103654633653",
  "lavender-tallow-deodorant": "53103654699189",
  "eucalyptus-bergamot-tallow-deodorant": "53103654797493",
  "eucalyptus-lemongrass-tallow-deodorant": "53103654863029",
  "ylang-ylang-blue-tansy-tallow-deodorant": "53103654961333",
  "frankincense-tallow-face-cream": "44853807218869",
  "radiance-lavender-frankincense-face-cream": "51947905679541",
  "tea-tree-frankincense": "53103549087925",
  "clear-skin-spirulina-face-mask": "51525528354997",
  "intensive-recovery-face-mask": "52763920826549"
};
  const applyFamilyMerchandisingDefault = (card, handle) => {
    if (isBodyCollection) return;
    const variant = familyMerchandisingVariants[handle];
    const select = card.querySelector('.noble-grid-variant');
    if (!variant || !select || select.dataset.nobleFamilyMerchandisingDefault) return;
    const preferred = [...select.options].find((option) => option.value === variant);
    if (!preferred) return;
    select.dataset.nobleFamilyMerchandisingDefault = variant;
    if (preferred.disabled) {
      const add = card.querySelector('.noble-grid-add');
      if (add) {
        const originallyDisabled = add.disabled;
        const syncAvailability = () => { add.disabled = originallyDisabled || Boolean(select.selectedOptions[0]?.disabled); };
        select.addEventListener('change', syncAvailability);
        syncAvailability();
      }
    }
    if (select.value !== variant) {
      select.value = variant;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };
  const scope = '#product-grid .card-wrapper[data-noble-phase1a]';
  const style = document.createElement('style');
  style.textContent = `
    ${scope} { display: flex !important; flex-direction: column !important; height: auto !important; width: 100%; }
    ${scope} > .card { flex: 0 0 auto; transform: none !important; }
    ${scope} .card__media { display: block; padding: 0 !important; width: 100%; transform: none !important; }
    ${scope} .card__media > .media {
      position: relative !important; width: 100% !important; height: auto !important;
      min-height: 0 !important; padding: 0 !important; aspect-ratio: 5 / 7 !important;
      overflow: hidden; transform: none !important; transition: none !important; background: #fff;
    }
    ${scope} .card__media > .media > picture,
    ${scope}:hover .card__media > .media > picture {
      position: absolute !important; inset: 0 !important; display: block !important;
      width: 100% !important; height: 100% !important; margin: 0 !important;
      padding: 0 !important; transform: none !important; visibility: visible !important;
      transition: opacity 180ms ease !important; overflow: hidden;
    }
    ${scope} .card__media > .media > picture > img,
    ${scope}:hover .card__media > .media > picture > img {
      position: absolute !important; inset: 0 !important; display: block !important;
      width: 100% !important; height: 100% !important; max-width: none !important;
      margin: 0 !important; padding: 0 !important; transform: none !important;
      opacity: 1 !important; visibility: visible !important; transition: none !important;
    }
    ${scope} .card__media > .media > picture:first-of-type,
    ${scope}:hover .card__media > .media > picture:first-of-type { opacity: 1 !important; z-index: 0; }
    ${scope} .card__media > .media > picture:first-of-type > img {
      object-fit: contain !important; object-position: center center !important;
    }
    ${scope} .card__media > .media > picture:nth-of-type(2) { opacity: 0 !important; z-index: 1; pointer-events: none !important; }
    ${scope} .card__media > .media > picture:nth-of-type(2) > img {
      object-fit: cover !important; object-position: center center !important;
    }
    ${scope} > .card-information { display: block !important; flex: 0 0 auto !important; padding-top: 0 !important; }
    ${scope} .card-information__wrapper {
      display: grid !important; grid-template-columns: minmax(0, 1fr);
      grid-template-rows: 2.6em 22px 20px 104px;
      gap: 6px !important; padding: 12px 0 0 !important; width: 100%;
      font-size: 14px; line-height: 1.3;
    }
    ${scope} .card-information__wrapper > * { margin: 0 !important; min-width: 0; }
    ${scope} .card-information__text {
      grid-row: 1; display: -webkit-box !important; -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; overflow: hidden; height: 2.6em !important;
      min-height: 0 !important; padding: 0 !important; font-size: inherit; line-height: 1.3 !important;
    }
    ${scope} .noble-grid-price { grid-row: 2; display: block !important; min-height: 0 !important; }
    ${scope} .noble-grid-price .price { margin: 0 !important; min-height: 0 !important; line-height: 1.4; }
    ${scope} .noble-card-rating, ${scope} .noble-phase1a-review {
      grid-row: 3; display: flex !important; align-items: center; min-height: 0 !important; height: 20px;
    }
    ${scope} .noble-phase1a-review > * { margin: 0 !important; }
    ${scope} .noble-grid-purchase > .noble-grid-add { margin-top: 56px !important; }
    ${scope} .noble-grid-purchase { grid-row: 4; display: block !important; margin: 0 !important; }
    ${scope} .noble-grid-form { display: grid; grid-template-columns: minmax(0, 1fr); grid-template-rows: 46px 48px; gap: 10px; margin: 0; }
    ${scope} .noble-grid-variant { grid-row: 1; height: 46px; margin: 0 !important; }
    ${scope} .noble-grid-add { grid-row: 2; height: 48px; min-height: 48px; margin: 0 !important; }
    ${scope} .card-information__wrapper > .price,
    ${scope} .card-information__wrapper > .loox-rating,
    ${scope} .card-information__top:empty { display: none !important; }
    @media (hover: hover) and (pointer: fine) {
      ${scope}[data-noble-hover-approved="true"]:hover .card__media > .media > picture:nth-of-type(2) { opacity: 1 !important; }
    }
    @media (prefers-reduced-motion: reduce) {
      ${scope} .card__media > .media > picture { transition: none !important; }
    }
  `;
  document.head.appendChild(style);
  const apply = () => {
    document.querySelectorAll('#product-grid .card-wrapper').forEach((card) => {
      const href = card.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
      const handle = href.split('/products/')[1]?.split(/[?#/]/)[0];

      const media = card.querySelector('.card__media > .media');
      if (!media) return;
      applyBodyMerchandisingDefault(card, handle);
      applyFamilyMerchandisingDefault(card, handle);
      if (card.dataset.noblePhase1a) return;
      card.dataset.noblePhase1a = handle;
      const body = card.querySelector('.card-information__wrapper');
      const noReviews = card.querySelector('.noble-grid-no-reviews');
      if (body && !body.querySelector(':scope > .noble-card-rating')) {
        const reviews = document.createElement('div');
        reviews.className = 'noble-phase1a-review';
        if (noReviews) reviews.appendChild(noReviews);
        body.insertBefore(reviews, body.querySelector('.noble-grid-purchase'));
      }
      if (handle === 'citrus-vanilla-tallow-deodorant') {
        const select = card.querySelector('.noble-grid-variant');
        const fullSize = select && [...select.options].find((option) => /(?:^|\s)3\s*oz(?:\s|$)/i.test(option.textContent));
        if (fullSize) {
          select.value = fullSize.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; apply(); });
  };
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
  schedule();
})();

(() => {
  if (!document.querySelector('#product-grid') || document.getElementById('noble-card-control-refinements')) return;
  const style = document.createElement('style');
  style.id = 'noble-card-control-refinements';
  style.textContent = `
    #product-grid .card-wrapper .noble-grid-variant {
      -webkit-appearance: none !important;
      appearance: none !important;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' fill='none' stroke='%2309243a' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") !important;
      background-repeat: no-repeat !important;
      background-position: right 12px center !important;
      background-size: 12px 8px !important;
      padding-right: 36px !important;
    }
    #product-grid .card-wrapper .card__media::before,
    #product-grid .card-wrapper .card__media::after,
    #product-grid .card-wrapper .card__media .media::before,
    #product-grid .card-wrapper .card__media .media::after,
    #product-grid .card-wrapper .card__media picture::before,
    #product-grid .card-wrapper .card__media picture::after {
      content: none !important;
      display: none !important;
      animation: none !important;
    }
  `;
  document.head.appendChild(style);
})();

(() => {
  const grid = document.querySelector('#product-grid');
  if (!grid || document.getElementById('noble-face-education-styles')) return;
  const labels = {
  "antioxidant-repair-balm": "ALL SKIN TYPES • BRIGHTEN + RENEW",
  "rejuvenate-tallow-face-cream": "DRY + MATURE",
  "soothe-tallow-face-cream-for-sensitive-or-reactive-skin": "SENSITIVE + REACTIVE",
  "clarify-tallow-face-cream": "CONGESTED + COMBINATION",
  "barrier-rescue-balm": "ECZEMA-PRONE + VERY DRY",
  "frankincense-tallow-face-cream": "ALL SKIN TYPES",
  "radiance-lavender-frankincense-face-cream": "ALL SKIN TYPES",
  "tea-tree-frankincense": "ACNE-PRONE + CONGESTED",
  "bare-unscented-whipped-tallow": "SENSITIVE + ALL SKIN TYPES",
  "rose-lemon-vanilla-face-cream": "DRY + DULL",
  "rejuvenate-serum": "DRY + MATURE",
  "soothe-serum": "SENSITIVE + REACTIVE",
  "clarify-serum": "CONGESTED + COMBINATION",
  "rejuvenate-toner": "DRY + MATURE",
  "soothe-toner": "SENSITIVE + REACTIVE",
  "clarify-toner": "CONGESTED + COMBINATION",
  "rejuvenating-face-mask": "DRY + MATURE",
  "clear-skin-spirulina-face-mask": "SENSITIVE + REACTIVE",
  "clarify-face-mask": "CONGESTED + COMBINATION",
  "nourish-soothe-eye-balm": "SENSITIVE + DELICATE EYE AREA",
  "cleansing-oil": "NORMAL + DRY • GENTLE CLEANSING",
  "peppermint-vanilla-whipped-tallow-body-cream": "DRY SKIN • RICH MOISTURE",
  "vanilla-bean-whipped-tallow-whole-body-cream": "DRY SKIN • RICH MOISTURE",
  "rosemary-mint-whole-body-whipped-tallow": "DRY SKIN • RICH MOISTURE",
  "orange-vanilla-whipped-tallow-whole-body-cream": "DRY SKIN • RICH MOISTURE",
  "lavender-eucalyptus-whipped-tallow-face-body-cream-v1-copy": "DRY SKIN • RICH MOISTURE",
  "orange-chamomile": "DRY SKIN • RICH MOISTURE",
  "atlas-cedarwood-bergamot-whipped-tallow-face-body-cream": "DRY SKIN • RICH MOISTURE",
  "eucalyptus-bergamot-tallow-body-cream": "DRY SKIN • RICH MOISTURE",
  "vanilla-bean-tallow-deodorant": "ALUMINUM-FREE • DAILY ODOR CARE",
  "citrus-vanilla-tallow-deodorant": "ALUMINUM-FREE • DAILY ODOR CARE",
  "orange-lemongrass-tallow-deodorant": "ALUMINUM-FREE • DAILY ODOR CARE",
  "geranium-tallow-deodorant": "ALUMINUM-FREE • DAILY ODOR CARE",
  "lavender-tallow-deodorant": "ALUMINUM-FREE • DAILY ODOR CARE",
  "eucalyptus-bergamot-tallow-deodorant": "ALUMINUM-FREE • DAILY ODOR CARE",
  "eucalyptus-lemongrass-tallow-deodorant": "ALUMINUM-FREE • DAILY ODOR CARE",
  "ylang-ylang-blue-tansy-tallow-deodorant": "ALUMINUM-FREE • DAILY ODOR CARE"
};
  const style = document.createElement('style');
  style.id = 'noble-face-education-styles';
  style.textContent = `
    #product-grid .card-wrapper[data-noble-phase1a] .card-information__wrapper {
      grid-template-rows: 28px 2.6em 22px 20px 104px !important;
    }
    #product-grid .card-wrapper[data-noble-phase1a] .noble-face-education {
      grid-row: 1;
      display: flex;
      align-items: flex-end;
      height: 28px;
      color: #194f47;
      font-family: var(--font-body-family);
      font-size: 10px;
      font-weight: 600;
      line-height: 14px;
      letter-spacing: .12em;
      text-transform: uppercase;
      margin: 0;
    }
    #product-grid .card-wrapper[data-noble-phase1a] .noble-face-education > span {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    #product-grid .card-wrapper[data-noble-phase1a] .card-information__text { grid-row: 2; }
    #product-grid .card-wrapper[data-noble-phase1a] .noble-grid-price { grid-row: 3; }
    #product-grid .card-wrapper[data-noble-phase1a] .noble-card-rating,
    #product-grid .card-wrapper[data-noble-phase1a] .noble-phase1a-review { grid-row: 4; }
    #product-grid .card-wrapper[data-noble-phase1a] .noble-grid-purchase { grid-row: 5; }
  `;
  document.head.appendChild(style);
  const apply = () => {
    document.querySelectorAll('#product-grid .card-wrapper').forEach((card) => {
      const body = card.querySelector('.card-information__wrapper');
      const title = body?.querySelector('.card-information__text');
      if (!title || body.querySelector(':scope > .noble-face-education')) return;
      const href = card.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
      const handle = href.split('/products/')[1]?.split(/[?#/]/)[0];
      const label = document.createElement('div');
      label.className = 'noble-face-education';
      const text = labels[handle];
      if (text) {
        const span = document.createElement('span');
        span.textContent = text;
        label.appendChild(span);
      } else {
        label.setAttribute('aria-hidden', 'true');
      }
      body.insertBefore(label, title);
    });
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; apply(); });
  };
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
  schedule();
})();

/* Selected-variant prices use the same option submitted by the collection ADD form. */
(() => {
  const selector = '#product-grid[data-noble-collection] .noble-grid-variant';
  const money = (value) => {
    const text = document.createElement('span');
    text.textContent = value;
    return '<price-money><bdi>' + text.innerHTML + '</bdi></price-money>';
  };
  const sync = (select) => {
    const option = select.selectedOptions[0];
    const card = select.closest('.card-wrapper');
    const price = card?.querySelector('.noble-grid-price .price');
    if (!option || !price || !option.dataset.price) return;
    const signature = [option.value, option.dataset.price, option.dataset.compare || '', option.disabled].join('|');
    if (price.dataset.nobleSelectedVariantPrice === signature) return;
    price.dataset.nobleSelectedVariantPrice = signature;
    price.querySelectorAll('.price__regular .price-item, .price__sale .price-item--sale').forEach((amount) => {
      amount.innerHTML = money(option.dataset.price);
    });
    price.querySelectorAll('.price__compare .price-item').forEach((amount) => {
      amount.innerHTML = money(option.dataset.compare || option.dataset.price);
    });
    price.classList.toggle('price--on-sale', Boolean(option.dataset.compare));
    const form = select.closest('form');
    const add = form?.querySelector('[type="submit"]');
    if (add) add.disabled = option.disabled;
  };
  const picturedDefaults = {
    'antioxidant-repair-balm': '1',
    'eucalyptus-bergamot-tallow-body-cream': '4',
    'atlas-cedarwood-bergamot-whipped-tallow-face-body-cream': '4',
    'orange-chamomile': '4'
  };
  const initialize = (select) => {
    if (!select.dataset.noblePicturedDefaultChecked) {
      select.dataset.noblePicturedDefaultChecked = 'true';
      const href = select.closest('.card-wrapper')?.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
      const handle = href.split('/products/')[1]?.split(/[?#/]/)[0];
      const size = picturedDefaults[handle];
      const option = size && [...select.options].find((item) => new RegExp('^' + size + '\\s*oz(?:\\s|$)', 'i').test(item.textContent.trim()));
      if (option && select.value !== option.value) {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    sync(select);
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      document.querySelectorAll(selector).forEach(initialize);
    });
  };
  document.addEventListener('change', (event) => {
    if (event.target.matches?.(selector)) sync(event.target);
  });
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
})();

}

(() => {
  const selector = '#product-grid .noble-grid-variant';
  const sync = (select) => {
    const card = select.closest('.card-wrapper');
    if (!card) return;
    let option = select.selectedOptions[0];
    if (option?.disabled) {
      const available = [...select.options].find(candidate => !candidate.disabled);
      if (available) {
        select.value = available.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        option = available;
      }
    }
    const image = card.querySelector('.card__media > .media > picture:first-of-type img');
    if (!option?.dataset.image || !image) return;
    const source = option.dataset.image;
    if (image.getAttribute('src') !== source) image.setAttribute('src', source);
    if (image.hasAttribute('srcset')) image.removeAttribute('srcset');
    if (image.hasAttribute('data-srcset')) image.removeAttribute('data-srcset');
    if (image.hasAttribute('data-src') && image.getAttribute('data-src') !== source) image.setAttribute('data-src', source);
    const alt = option.dataset.imageAlt || select.getAttribute('aria-label') + ' — ' + option.textContent.trim();
    if (image.alt !== alt) image.alt = alt;
    image.closest('picture').querySelectorAll('source').forEach(sourceElement => sourceElement.remove());
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      document.querySelectorAll(selector).forEach(sync);
    });
  };
  document.addEventListener('change', event => {
    if (event.target.matches(selector)) sync(event.target);
  });
  const start = () => {
    const grid = document.querySelector('#product-grid');
    if (!grid) return;
    new MutationObserver(schedule).observe(grid, {childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset', 'data-src', 'selected']});
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
